import React, { useRef } from 'react';
import classNames from 'classnames';

import css from './FieldCodeInput.module.css';

export default function FieldCodeInput({ length = 6, onComplete }) {
  const inputsRef = useRef([]);

  const focusNext = idx => {
    if (idx < length - 1) {
      inputsRef.current[idx + 1]?.focus();
    }
  };

  const focusPrev = idx => {
    if (idx > 0) {
      inputsRef.current[idx - 1]?.focus();
    }
  };

  const collectCode = () => {
    return inputsRef.current.map(input => input?.value || '').join('');
  };

  const handleChange = (e, idx) => {
    const value = e.target.value.replace(/\D/g, ''); // allow digits only

    if (!value) {
      e.target.value = '';
      return;
    }

    // Handle paste or multiple digits typed quickly
    if (value.length > 1) {
      const digits = value.split('');
      for (let i = 0; i < digits.length && idx + i < length; i++) {
        if (inputsRef.current[idx + i]) {
          inputsRef.current[idx + i].value = digits[i];
        }
      }
      const nextIndex = Math.min(idx + value.length, length - 1);
      inputsRef.current[nextIndex]?.focus();
    } else {
      // Single digit typing
      e.target.value = value;
      focusNext(idx);
    }

    const code = collectCode();
    if (code.length === length && onComplete) {
      onComplete(code);
    }
  };

  const handleKeyDown = (e, idx) => {
    if (e.key === 'Backspace') {
      if (e.target.value) {
        e.target.value = '';
      } else {
        focusPrev(idx);
        if (inputsRef.current[idx - 1]) {
          inputsRef.current[idx - 1].value = '';
        }
      }
    }
  };

  const handlePaste = (e, idx) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData('Text').replace(/\D/g, '');
    if (!pasteData) return;

    for (let i = 0; i < pasteData.length && idx + i < length; i++) {
      if (inputsRef.current[idx + i]) {
        inputsRef.current[idx + i].value = pasteData[i];
      }
    }

    const nextIndex = Math.min(idx + pasteData.length, length - 1);
    inputsRef.current[nextIndex]?.focus();

    const code = collectCode();
    if (code.length === length && !code.includes('') && onComplete) {
      onComplete(code);
    }
  };
  return (
    <div className={css.codeInput}>
      {Array.from({ length }).map((_, idx) => (
        <input
          key={idx}
          maxLength={1}
          className={classNames(css.digitBox)}
          onChange={e => handleChange(e, idx)}
          onKeyDown={e => handleKeyDown(e, idx)}
          onPaste={e => handlePaste(e, idx)}
          ref={el => (inputsRef.current[idx] = el)}
        />
      ))}
    </div>
  );
}
